export const useSxStyles = () => {
  return {
    paperWidthMd: {
      width: 580,
    },
    dialogActions: {
      margin: '8px 20px',
    },
    error: {
      color: 'red',
      fontSize: '0.75rem',
    },
  };
};
